module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS.f0153a3.ttf";